var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.classes }, [
    _vm.message.content.isRoutine
      ? _c(
          "div",
          {
            ref: "productItemRoutineHeader",
            staticClass: "products-item-routine-header",
          },
          [
            _vm.item.routineTitle
              ? _c("div", { staticClass: "products-item-routine-title" }, [
                  _vm._v(_vm._s(_vm.item.routineTitle)),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.item.routineDescription
              ? _c("div", {
                  staticClass: "products-item-routine-description",
                  domProps: {
                    innerHTML: _vm._s(_vm.sanitizedRoutineDescriptionMarkup),
                  },
                })
              : _vm._e(),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.item.isEmpty
      ? _c("div", { staticClass: "products-item-routine-empty-message" }, [
          _c(
            "div",
            { staticClass: "products-item-routine-empty-message-icon" },
            [_vm._v("⚠")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "products-item-routine-empty-message-text" },
            [_vm._v(_vm._s(_vm.$t("product.emptyRoutineItem")))]
          ),
        ])
      : _c(
          "div",
          {
            ref: "productItemContainer",
            staticClass: "products-item-container",
            style: _vm.containerHeight,
          },
          [
            _c(
              "div",
              { staticClass: "products-item-header" },
              [
                _c(
                  "div",
                  {
                    staticClass: "products-item-badges",
                    on: { click: _vm.clickOnItem },
                  },
                  _vm._l(_vm.productBadges, function (productBadge) {
                    return _c("badge", {
                      key: productBadge.featureFlagName,
                      attrs: {
                        "badge-type": productBadge.badge.type,
                        text: productBadge.badge.text,
                        color: productBadge.badge.color,
                      },
                    })
                  }),
                  1
                ),
                _vm._v(" "),
                !!_vm.item.explanation
                  ? _c("explanation-button", {
                      attrs: {
                        role: "tooltip",
                        "aria-labelledby": _vm.explanationId,
                        open: _vm.explanationVisible,
                        "on-click": _vm.explanationButtonClick,
                      },
                      on: { "esc-pressed": _vm.closeExplanation },
                    })
                  : _vm._e(),
                _vm._v(" "),
                !!_vm.item.explanation
                  ? _c("explanation", {
                      attrs: {
                        id: _vm.explanationId,
                        item: _vm.item,
                        message: _vm.message,
                        "is-visible": _vm.explanationVisible,
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "products-item-image-link",
                    attrs: {
                      href: _vm.productUrl,
                      target: _vm.productTarget,
                      title: _vm.item.title,
                    },
                    on: {
                      click: _vm.clickOnItem,
                      keydown: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "space", 32, $event.key, [
                            " ",
                            "Spacebar",
                          ])
                        ) {
                          return null
                        }
                        $event.preventDefault()
                        return _vm.clickOnItem.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c("div", {
                      staticClass: "products-item-image",
                      style: {
                        "background-image": "url('" + _vm.item.image_url + "')",
                      },
                    }),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "products-item-body" },
              [
                _c("div", { staticClass: "products-item-body-top-container" }, [
                  _c(
                    "div",
                    { staticClass: "products-item-body-top-container-header" },
                    [
                      _c(
                        "div",
                        { staticClass: "products-item-title-and-subtitle" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "products-item-title",
                              on: { click: _vm.clickOnItem },
                            },
                            [_vm._v(_vm._s(_vm.item.title))]
                          ),
                          _vm._v(" "),
                          !!_vm.item.subtitle
                            ? _c(
                                "div",
                                {
                                  staticClass: "products-item-subtitle",
                                  on: { click: _vm.clickOnItem },
                                },
                                [_vm._v(_vm._s(_vm.item.subtitle))]
                              )
                            : _vm._e(),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.showCustomerRatings
                    ? _c(
                        "div",
                        { staticClass: "products-item-star-rating" },
                        [
                          _c("star-rating", {
                            attrs: {
                              inline: true,
                              "star-size": 10,
                              rating: Number(_vm.item.customerRating),
                              "read-only": true,
                              increment: 0.01,
                              "fixed-points": 1,
                              "text-class": "products-item-rating",
                              "rounded-corners": true,
                              "border-width": 2,
                              "active-color": "#505052",
                              "border-color": "#505052",
                              "inactive-color": "#EFF3F6",
                            },
                          }),
                          _vm._v(" "),
                          _vm.showCustomerRatingCount
                            ? _c(
                                "span",
                                { staticClass: "products-item-rating-count" },
                                [
                                  _vm._v(
                                    "(" +
                                      _vm._s(_vm.item.customerRatingCount) +
                                      ")"
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showPrice
                    ? _c(
                        "div",
                        { staticClass: "products-item-price" },
                        [_c("price", { attrs: { item: _vm.item } })],
                        1
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _vm.showAttributeMatching
                  ? _c(
                      "div",
                      { staticClass: "products-item-body-middle-container" },
                      [
                        _vm.showAttributeMatching
                          ? _c("attribute-matching", {
                              attrs: {
                                role: "button",
                                tabindex: "0",
                                item: _vm.item,
                                message: _vm.message,
                                "is-list-expanded":
                                  _vm.isAttributeMatchingListExpanded,
                                "keep-expanded":
                                  _vm.keepAttributeMatchingExpanded,
                                "aria-expanded": _vm.matchingListAriaExpanded,
                                "aria-controls": _vm.matchingListId,
                                "matching-list-title-id":
                                  _vm.matchingListTitleId,
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.attributeMatchingClick.apply(
                                    null,
                                    arguments
                                  )
                                },
                                keydown: [
                                  function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    $event.preventDefault()
                                    return _vm.attributeMatchingClick.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                  function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "space",
                                        32,
                                        $event.key,
                                        [" ", "Spacebar"]
                                      )
                                    ) {
                                      return null
                                    }
                                    $event.preventDefault()
                                    return _vm.attributeMatchingClick.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                ],
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showAttributeMatching
                  ? _c("attribute-matching-list", {
                      attrs: {
                        id: _vm.matchingListId,
                        "aria-labelledby": _vm.matchingListTitleId,
                        "is-list-expanded": _vm.isAttributeMatchingListExpanded,
                        "attribute-matches-success":
                          _vm.attributeMatchesSuccess,
                        "attribute-matches-fail": _vm.attributeMatchesFail,
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "products-item-body-bottom-container" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "products-item-body-bottom-container-items",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "products-item-body-bottom-container-item-button",
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "products-item-button",
                                attrs: {
                                  type: "button",
                                  "data-product-identifier":
                                    _vm.item.productIdentifier,
                                  "data-product-identifier-2":
                                    _vm.item.productIdentifier2,
                                },
                                on: { click: _vm.clickOnItem },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "products-item-button-text" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.productDetailPageButtonTitle)
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.showAddToCartButton
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "products-item-body-bottom-container-add-to-cart",
                              },
                              [
                                _c("add-to-cart-button", {
                                  attrs: {
                                    item: _vm.item,
                                    message: _vm.message,
                                  },
                                  on: {
                                    "product-added-to-cart": function ($event) {
                                      return _vm.$emit(
                                        "product-added-to-cart",
                                        $event
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    ),
                  ]
                ),
              ],
              1
            ),
          ]
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }